import { api } from './api';

// Opens the affiliate partner link via the backend /go redirect (which records
// the click + analytics). For hotels/experiences we first cache the offer so
// the backend can resolve it. A tab is opened synchronously to avoid popup
// blockers, then redirected once the go URL is ready.
// Enriches every click with attribution (surface/placement/source/destination + session)
// so the ONE central attribution engine captures where each monetizable click came from.
export async function openDeal({ type, offer, sessionId, surface, placement, source, extra }) {
  const win = window.open('about:blank', '_blank');
  try {
    if ((type === 'hotel' || type === 'experience') && offer.offer_id) {
      await api.cacheOffers([offer]);
    }
    const offerId = offer.offer_id || offer.id;
    const attr = {
      ...(sessionId ? { session_id: sessionId } : {}),
      ...(surface ? { surface } : {}),
      ...(placement ? { placement } : {}),
      ...(source ? { source } : {}),
      ...(offer.destination || offer.dest_slug ? { destination: offer.destination || offer.dest_slug } : {}),
      ...(offer.campaign_id ? { campaign_id: offer.campaign_id } : {}),
      ...(extra || {}),
    };
    const url = api.goVerticalUrl(type, offerId, attr);
    if (win) win.location.href = url; else window.location.href = url;
  } catch (e) {
    if (win) win.close();
  }
}
